import React, {Fragment, useState, useEffect} from 'react';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import { makeStyles } from '@material-ui/core/styles';
import Loader from 'react-loader-spinner';
import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Slider from '@material-ui/core/Slider';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Board from '@lourenci/react-kanban'
import YCard from './../YCard';
import '@lourenci/react-kanban/dist/styles.css'

import axios from 'axios';
import apiUrl from '../../constants.js';
import history from '../../history';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  slider: {
    width: 300,
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  titleMargin: {
    flexGrow: 1,
    margin: '10px'
  },
  rowTitleMargin: {
    margin: '10px'
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    margin: '15px 0px'
  },
  fixedHeight: {
    height: 240,
  },
  spinnerDiv: {
    height: '100px',
    width: '400px',
    textAlign: 'center',
  },
  spinnerDiv4: {
    height: '100px',
    width: '100%',
    textAlign: 'center',
  },
  spinnerDiv1: {
    height: '400px',
    width: '100%',
    textAlign: 'center',
  },
  spinner: {
    marginTop: '60px',
    marginBottom: '60px'
  },
  btnRight: {
    float: 'right',
    margin: '10px'
  },
  formControl: {
    margin: theme.spacing(1),
    width: '100%',
    margin: '15px 0px'
  },
  mainTitleMarginRight: {
    marginRight: '10px'
  },
  padding4Labels: {
    padding: '10px 0px',
  },
  imgPreview: {
    maxWidth: '100px',
    margin: 'auto'
  }
}));



const RowsStructure = () => {
  const classes = useStyles();

  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('user_id');

  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openCol, setOpenCol] = useState(false);
  const [openColEdit, setOpenColEdit] = useState(false);
  const [image1, setImage1] = useState({});
  const [image2, setImage2] = useState({});

  const [image1Edit, setImage1Edit] = useState('');
  const [image2Edit, setImage2Edit] = useState('');

  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [row, setRow] = useState({
    title: '',
    colorTitle: '#000000',
    subTitle: '',
    colorSubTitle: '#000000',
    titleAlign: 'left',
    position: 0
  });

  const [rowSelected, setRowSelected] = useState({
    idSelected: null,
    titleSelected: '',
    colorTitleSelected: '#000000',
    subTitleSelected: '',
    colorSubTitleSelected: '#000000',
    titleAlignSelected: 'left',
    positionSelected: 0
  });

  const [column, setColumn] = useState({
    titleColumn: '',
    urlColumn: '',
    descriptionColumn: '',
    image1Column: null,
    image2Column: null,
    idCompanyColumn: '',
    idRowColumn: '',
    widthColumn: '',
    orderColumn: 0,
    totalColumns: 0
  });

  const [columnEdit, setColumnEdit] = useState({
    idEdit: '',
    titleColumnEdit: '',
    urlColumnEdit: '',
    descriptionColumnEdit: '',
    image1ColumnEdit: null,
    image2ColumnEdit: null,
    idCompanyColumnEdit: '',
    idRowColumnEdit: '',
    widthColumnEdit: '',
    orderColumnEdit: 0,
    totalColumnsEdit: 0
  });

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    let url = apiUrl+"v1/rows/get?id_user="+userId;

    let city_prefix = process.env.REACT_APP_CITY_PREFIX;

    if(typeof city_prefix !== "undefined"){
      url = url + "&city_prefix="+city_prefix;
    }

    axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Authorization': token,
        }
      }
    )
    .then(function (response) {
        setRows(response.data['rows']);
        setCompanies(response.data['companies']);
        setLoading(false);
    })
    .catch(function (error) {
      console.log(error);
      setLoading(false);
      localStorage.removeItem('user_id');
      localStorage.removeItem('token');
      history.push(process.env.REACT_APP_PREFIX_DIR+'/login');
    });
  };

  const handleModalColumn = (action) => {
    setOpenCol(action);

    if(!action) {
      setColumn({
        titleColumn: '',
        urlColumn: '',
        descriptionColumn: '',
        image1Column: null,
        image2Column: null,
        idCompanyColumn: '',
        idRowColumn: '',
        widthColumn: '',
        orderColumn: 0,
        totalColumns: 0
      });
    }
  };

  const handleModalColumnEdit = (action, storeBox) => {

    console.log(storeBox);

    // created_at: "2020-07-11 19:00:18"
    // description: "OKOKOK"
    // fantasy_name: "Pittier"
    // id: 3
    // id_company: 5035
    // id_row: 1
    // image_1: "images/e24016a2262c79ea0260db56f7a323c4.jpeg"
    // image_2: "images/6738d77cf951a51b018487f82ae66ed6.jpeg"
    // is_enabled: 1
    // order: 1
    // title: "Pittier prueba"
    // updated_at: "2020-07-11 23:50:19"
    // url: "https://pittier.max.delivery/"
    // url_prefix: "http://localhost:8000"
    // width: "8"

    setOpenColEdit(action);

    if(!action) {
      setColumnEdit({
        idEdit: '',
        titleColumnEdit: '',
        urlColumnEdit: '',
        descriptionColumnEdit: '',
        image1ColumnEdit: null,
        image2ColumnEdit: null,
        idCompanyColumnEdit: '',
        idRowColumnEdit: '',
        widthColumnEdit: '',
        orderColumnEdit: 0,
        totalColumnsEdit: 0
      });
    } else {

      setImage1Edit(storeBox.url_prefix+'/'+storeBox.image_1);
      setImage2Edit(storeBox.url_prefix+'/'+storeBox.image_2);

      setColumnEdit({
        idEdit: storeBox.id,
        titleColumnEdit: storeBox.title,
        urlColumnEdit: storeBox.url,
        descriptionColumnEdit: storeBox.description,
        image1ColumnEdit: null,
        image2ColumnEdit: null,
        idCompanyColumnEdit: storeBox.id_company,
        idRowColumnEdit: storeBox.id_row,
        widthColumnEdit: storeBox.width,
        orderColumnEdit: storeBox.order,
        totalColumnsEdit: 0
      });
    }
  };

  const handleModalEdit = (action, index) => {
    if(typeof index !== "undefined"){
      setRowSelected({
        idSelected: rows[index].id,
        titleSelected: rows[index].title,
        colorTitleSelected: rows[index].titlecolor,
        subTitleSelected: rows[index].subtitle,
        colorSubTitleSelected: rows[index].subtitlecolor,
        titleAlignSelected: rows[index].textalign,
        positionSelected: rows[index].order
      });
    } else {
      setRowSelected({
        idSelected: '',
        titleSelected: '',
        colorTitleSelected: '#000000',
        subTitleSelected: '',
        colorSubTitleSelected: '#000000',
        titleAlignSelected: 'left',
        positionSelected: 0
      });
    }

    setOpenEdit(action);
  };

  const handleSubmitDialogEdit = (e) => {
    e.preventDefault();

    setLoading(true);
    handleModalEdit(false);

    let url = apiUrl+"v1/rows/update/"+rowSelected.idSelected;
    let data = new FormData();

    let city_prefix = process.env.REACT_APP_CITY_PREFIX;

    if(typeof city_prefix !== "undefined"){
      data.append("city_prefix", city_prefix);
    }

    data.append("id_user", userId);

    for ( var key in rowSelected ) {
      data.append(key, rowSelected[key]);
    }

    console.log(data);

    axios.post(url, data, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Authorization': token,
        }
      }
    )
    .then(function (response) {
      console.log(response);
      setRows(response.data);

      setRowSelected({
        idSelected: null,
        titleSelected: '',
        colorTitleSelected: '#000000',
        subTitleSelected: '',
        colorSubTitleSelected: '#000000',
        titleAlignSelected: 'left',
        positionSelected: 0
      });

      setLoading(false);
    })
    .catch(function (error) {
      console.log(error);
      // showAlert("HA OCURRIDO UN ERROR AL INTENTAR ACTUALIZAR LOS DATOS, POR FAVOR INTENTE DE NUEVO MÁS TARDE", "error");
      setLoading(false);
    });
  }

  const handleSubmitDialogColumnEdit = (e) => {
    e.preventDefault();

    console.log(columnEdit);

    setLoading(true);
    handleModalColumnEdit(false);

    let url = apiUrl+"v1/columns/update/"+columnEdit.idEdit;
    let data = new FormData();

    let city_prefix = process.env.REACT_APP_CITY_PREFIX;

    if(typeof city_prefix !== "undefined"){
      data.append("city_prefix", city_prefix);
    }

    data.append("id_user", userId);

    for ( var key in columnEdit ) {
      data.append(key, columnEdit[key]);
    }

    if(columnEdit.image1ColumnEdit !== null){
      data.append(
        "image1Edit",
        columnEdit.image1ColumnEdit,
        columnEdit.image1ColumnEdit.name
      );
    }

    if(columnEdit.image2ColumnEdit !== null){
      data.append(
        "image2Edit",
        columnEdit.image2ColumnEdit,
        columnEdit.image2ColumnEdit.name
      );
    }

    axios.post(url, data, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Authorization': token,
        }
      }
    )
    .then(function (response) {
      console.log(response);
      setRows(response.data);
      setLoading(false);
    })
    .catch(function (error) {
      console.log(error);
      setLoading(false);
    });

  };

  const handleSubmitDialogColumn = (e) => {
    e.preventDefault();

    setLoading(true);
    handleModalColumn(false);

    let url = apiUrl+"v1/columns/add";
    let data = new FormData();

    let city_prefix = process.env.REACT_APP_CITY_PREFIX;

    if(typeof city_prefix !== "undefined"){
      data.append("city_prefix", city_prefix);
    }

    data.append("id_user", userId);

    for ( var key in column ) {
      data.append(key, column[key]);
    }

    if(typeof image1.image1Column !== "undefined"){
      data.append(
        "image1",
        image1.image1Column,
        image1.image1Column.name
      );
    }

    if(typeof image2.image2Column !== "undefined"){
      data.append(
        "image2",
        image2.image2Column,
        image2.image2Column.name
      );
    }

    axios.post(url, data, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Authorization': token,
        }
      }
    )
    .then(function (response) {
      console.log(response);
      setRows(response.data);
      setLoading(false);
    })
    .catch(function (error) {
      console.log(error);
      setLoading(false);
    });


  }

  const handleModal = (action) => {
    setOpen(action);

    if(!action) {
      setRow({
        title: '',
        colorTitle: '#000000',
        subTitle: '',
        colorSubTitle: '#000000',
        titleAlign: 'left',
        position: 0
      });
    }
  };

  const handleSubmitDialog = (e) => {
    e.preventDefault();

    setLoading(true);
    handleModal(false);

    let url = apiUrl+"v1/rows/add";
    let data = new FormData();

    let city_prefix = process.env.REACT_APP_CITY_PREFIX;

    if(typeof city_prefix !== "undefined"){
      data.append("city_prefix", city_prefix);
    }

    data.append("id_user", userId);

    for ( var key in row ) {
      data.append(key, row[key]);
    }

    console.log(data);

    axios.post(url, data, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Authorization': token,
        }
      }
    )
    .then(function (response) {
      console.log(response);
      setRows(response.data);

      setRow({
        title: '',
        colorTitle: '#000000',
        subTitle: '',
        colorSubTitle: '#000000',
        titleAlign: 'left',
        position: 0
      });

      setLoading(false);
    })
    .catch(function (error) {
      console.log(error);
      // showAlert("HA OCURRIDO UN ERROR AL INTENTAR ACTUALIZAR LOS DATOS, POR FAVOR INTENTE DE NUEVO MÁS TARDE", "error");
      setLoading(false);
    });
  }

  const valuetext = (value) => {
    return `${value}`;
  }

  const handleChangeDialog = e => {
    setRow({
      ...row,
      [e.target.name]: e.target.value
    });
  };

  const handleChangeDialogColumn = e => {
    setColumn({
      ...column,
      [e.target.name]: e.target.value
    });
  };

  const handleChangeDialogColumnEdit = e => {
    setColumnEdit({
      ...columnEdit,
      [e.target.name]: e.target.value
    });
  };

  const handleChangeDialogSelected = e => {
    setRowSelected({
      ...rowSelected,
      [e.target.name]: e.target.value
    });
  };

  const handleSlider = (coords, value) => {
    setRow({
      ...row,
      'position': value
    });
  };

  const handleSliderColumn = (coords, value) => {
    setColumn({
      ...column,
      'orderColumn': value
    });
  };

  const handleSliderSelected = (coords, value) => {
    setRowSelected({
      ...rowSelected,
      'positionSelected': value
    });
  };

  const onChangeFileHandler = (e) => {
    setColumn({
      ...column,
      [e.target.name]: URL.createObjectURL(e.target.files[0])
    });
    switch (e.target.name) {
      case "image1Column":
        setImage1({ image1Column: e.target.files[0] });
        break;
      case "image2Column":
        setImage2({ image2Column: e.target.files[0] });
        break;
    }
  }

  const onChangeFileHandlerEdit = (e) => {
    setColumnEdit({
      ...columnEdit,
      [e.target.name]: e.target.files[0]
    });
    switch (e.target.name) {
      case "image1ColumnEdit":
        setImage1Edit(URL.createObjectURL(e.target.files[0]));
        break;
      case "image2ColumnEdit":
        setImage2Edit(URL.createObjectURL(e.target.files[0]));
        break;
    }
  }

  const handleRowColumn = (e) => {
    const row = rows.filter(row => row.id === e.target.value);

    setColumn({
      ...column,
      'orderColumn': 0,
      'idRowColumn': e.target.value,
      'totalColumns': row[0].board.columns.length
    });
  }

  const handleRowColumnEdit = (e) => {
    const row = rows.filter(row => row.id === e.target.value);

    setColumnEdit({
      ...columnEdit,
      'orderColumnEdit': 0,
      'idRowColumnEdit': e.target.value,
      'totalColumnsEdit': row[0].board.columns.length
    });
  }

  const removeColumn = (card) => {
    console.log(card);
  };

  const removeCard = (board, column, card) => {
    console.log(board);
    console.log(column);
    console.log(card);
  };

  const draggingCard = (card, from, to, last) => {
    console.log(card);
    console.log(from);
    console.log(to);
  }

  const draggingColumn =  (column, source, destination) => {
    console.log(column);
    console.log(source);
    console.log(destination);

    setLoading(true);

    let url = apiUrl+"v1/columns/update-position/"+column.id;
    let data = new FormData();

    let city_prefix = process.env.REACT_APP_CITY_PREFIX;

    if(typeof city_prefix !== "undefined"){
      data.append("city_prefix", city_prefix);
    }

    data.append("id_user", userId);
    data.append("from", source.fromPosition);
    data.append("to", destination.toPosition);

    axios.post(url, data, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Authorization': token,
        }
      }
    )
    .then(function (response) {
      console.log(response);
      setRows(response.data);
      setLoading(false);
    })
    .catch(function (error) {
      console.log(error);
      // showAlert("HA OCURRIDO UN ERROR AL INTENTAR ACTUALIZAR LOS DATOS, POR FAVOR INTENTE DE NUEVO MÁS TARDE", "error");
      setLoading(false);
    });

  }

  const removeRow = (index) => {
    if(window.confirm('¿Está seguro de eliminar esta fila y toda su información asociada?')){
      setLoading(true);
      let url = apiUrl+"v1/rows/delete/"+rows[index].id+"?id_user="+userId;
      axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': token,
          }
        }
      )
      .then(function (response) {
        setRows(response.data);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
    }
  };

  const { title, colorTitle, subTitle, colorSubTitle, titleAlign, position } = row;
  const { titleSelected, colorTitleSelected, subTitleSelected, colorSubTitleSelected, titleAlignSelected, positionSelected } = rowSelected;
  const { titleColumn, urlColumn, descriptionColumn, image1Column, image2Column, idCompanyColumn, idRowColumn, widthColumn, orderColumn, totalColumns } = column;
  const { titleColumnEdit, urlColumnEdit, descriptionColumnEdit, image1ColumnEdit, image2ColumnEdit, idCompanyColumnEdit, idRowColumnEdit, widthColumnEdit, orderColumnEdit, totalColumnsEdit } = columnEdit;

  return (
    <Fragment>
    <div>
      <Dialog
        open={openCol}
        onClose={() => handleModalColumn(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
        maxWidth = {'md'}
      >
      <form onSubmit={(e) => handleSubmitDialogColumn(e)}>
        <DialogTitle id="alert-dialog-title">{"Agregar Nueva STORE BOX"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          { loading ?
            <Grid item xs={12} sm={12} className={classes.spinnerDiv4}>
              <Loader
                type="Oval"
                color="#00BFFF"
                height={50}
                width={50}
                className={classes.spinner4}
              />
            </Grid>
            :
            <Fragment>

            {/*
               titleColumn,
               urlColumn,
               descriptionColumn,
               image1Column,
               image2Column,
               idCompanyColumn,
               idRowColumn,
               widthColumn,
               orderColumn*/}

              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                label="Titulo de la Tienda"
                name="titleColumn"
                type="text"
                value={titleColumn}
                onChange={handleChangeDialogColumn}
              />

              <TextareaAutosize
                aria-label="Descripción"
                rowsMin={4}
                required
                placeholder="Descripción"
                variant="outlined"
                className="form-control"
                name="descriptionColumn"
                value={descriptionColumn}
                onChange={handleChangeDialogColumn}
                />

              <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                  <FormControl variant="outlined" className={classes.formControl}>
                    <InputLabel id="demo-simple-select-outlined-label">Restaurantes</InputLabel>
                      <Select
                        label="Restaurantes"
                        name="idCompanyColumn"
                        onChange={handleChangeDialogColumn}
                        value={idCompanyColumn}
                        required
                      >
                        {
                          companies.map((company, index) => (
                            <MenuItem value={company.id} key={index}>{company.fantasy_name}</MenuItem>
                          ))
                        }
                      </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <FormControl variant="outlined" className={classes.formControl}>
                    <InputLabel id="demo-simple-select-outlined-label">Fila</InputLabel>
                      <Select
                        label="Fila"
                        name="idRowColumn"
                        onChange={handleRowColumn}
                        value={idRowColumn}
                        required
                      >
                        {
                          rows.map((row, index) => (
                            <MenuItem value={row.id} key={index}>{row.title}</MenuItem>
                          ))
                        }
                      </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <FormControl variant="outlined" className={classes.formControl}>
                    <InputLabel id="demo-simple-select-outlined-label">Ancho de la tienda</InputLabel>
                      <Select
                        label="Ancho de la tienda"
                        name="widthColumn"
                        onChange={handleChangeDialogColumn}
                        value={widthColumn}
                        required
                      >
                        <MenuItem value={"12"}>100%</MenuItem>
                        <MenuItem value={"8"}>66,66%</MenuItem>
                        <MenuItem value={"6"}>50%</MenuItem>
                        <MenuItem value={"4"}>33,33%</MenuItem>
                        <MenuItem value={"3"}>25%</MenuItem>
                      </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                label="URL de la Tienda"
                name="urlColumn"
                type="text"
                value={urlColumn}
                onChange={handleChangeDialogColumn}
              />

              <Grid container spacing={1}>
                <Grid item xs={12} sm={6}>
                  <FormGroup component="fieldset">
                    <FormLabel component="legend">Imagen Desktop</FormLabel>

                    { image1Column!==null ?
                      <div className="previewBox">
                        <a href={image1Column} target="_blank">
                          <img
                            src={image1Column}
                            className={classes.imgPreview}
                            />
                        </a>
                      </div>
                      :
                      null
                    }

                    <input
                       type="file"
                       name="image1Column"
                       required
                       className={classes.padding4Labels}
                       onChange={(e) => onChangeFileHandler(e)}
                       accept="image/x-png,image/gif,image/jpeg"
                       />
                  </FormGroup>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormGroup component="fieldset">
                    <FormLabel component="legend">Imagen Mobile</FormLabel>

                    { image2Column!==null ?
                      <div className="previewBox">
                        <a href={image2Column} target="_blank">
                          <img
                            src={image2Column}
                            className={classes.imgPreview}
                            />
                        </a>
                      </div>

                      :
                      null
                    }

                    <input
                       type="file"
                       name="image2Column"
                       required
                       className={classes.padding4Labels}
                       onChange={(e) => onChangeFileHandler(e)}
                       accept="image/x-png,image/gif,image/jpeg"
                       />
                  </FormGroup>
                </Grid>
              </Grid>


            </Fragment>
          }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        { loading ?
            null
          :
            <Fragment>
              <Button onClick={() => handleModalColumn(false)} color="primary">
                Cerrar
              </Button>
              <Button type="submit" color="primary" autoFocus>
                Crear
              </Button>
            </Fragment>
        }
        </DialogActions>
        </form>
      </Dialog>
    </div>


    <div>
      <Dialog
        open={openColEdit}
        onClose={() => handleModalColumnEdit(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
        maxWidth = {'md'}
      >
      <form onSubmit={(e) => handleSubmitDialogColumnEdit(e)}>
        <DialogTitle id="alert-dialog-title">{"Editar STORE BOX"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          { loading ?
            <Grid item xs={12} sm={12} className={classes.spinnerDiv4}>
              <Loader
                type="Oval"
                color="#00BFFF"
                height={50}
                width={50}
                className={classes.spinner4}
              />
            </Grid>
            :
            <Fragment>

              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                label="Titulo de la Tienda"
                name="titleColumnEdit"
                type="text"
                value={titleColumnEdit}
                onChange={handleChangeDialogColumnEdit}
              />

              <TextareaAutosize
                aria-label="Descripción"
                rowsMin={4}
                required
                placeholder="Descripción"
                variant="outlined"
                className="form-control"
                name="descriptionColumnEdit"
                value={descriptionColumnEdit}
                onChange={handleChangeDialogColumnEdit}
                />

              <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                  <FormControl variant="outlined" className={classes.formControl}>
                    <InputLabel id="demo-simple-select-outlined-label">Restaurantes</InputLabel>
                      <Select
                        label="Restaurantes"
                        name="idCompanyColumnEdit"
                        onChange={handleChangeDialogColumnEdit}
                        value={idCompanyColumnEdit}
                        required
                      >
                        {
                          companies.map((company, index) => (
                            <MenuItem value={company.id} key={index}>{company.fantasy_name}</MenuItem>
                          ))
                        }
                      </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <FormControl variant="outlined" className={classes.formControl}>
                    <InputLabel id="demo-simple-select-outlined-label">Fila</InputLabel>
                      <Select
                        label="Fila"
                        name="idRowColumnEdit"
                        onChange={handleRowColumnEdit}
                        value={idRowColumnEdit}
                        required
                      >
                        {
                          rows.map((row, index) => (
                            <MenuItem value={row.id} key={index}>{row.title}</MenuItem>
                          ))
                        }
                      </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={4}>
                  <FormControl variant="outlined" className={classes.formControl}>
                    <InputLabel id="demo-simple-select-outlined-label">Ancho de la tienda</InputLabel>
                      <Select
                        label="Ancho de la tienda"
                        name="widthColumnEdit"
                        onChange={handleChangeDialogColumnEdit}
                        value={widthColumnEdit}
                        required
                      >
                        <MenuItem value={"12"}>100%</MenuItem>
                        <MenuItem value={"8"}>66,66%</MenuItem>
                        <MenuItem value={"6"}>50%</MenuItem>
                        <MenuItem value={"4"}>33,33%</MenuItem>
                        <MenuItem value={"3"}>25%</MenuItem>
                      </Select>
                  </FormControl>
                </Grid>
              </Grid>

              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                label="URL de la Tienda"
                name="urlColumnEdit"
                type="text"
                value={urlColumnEdit}
                onChange={handleChangeDialogColumnEdit}
              />

              <Grid container spacing={1}>
                <Grid item xs={12} sm={6}>
                  <FormGroup component="fieldset">
                    <FormLabel component="legend">Imagen Desktop</FormLabel>

                    { image1Edit!=='' ?
                      <div className="previewBox">
                        <a href={image1Edit} target="_blank">
                          <img
                            src={image1Edit}
                            className={classes.imgPreview}
                            />
                        </a>
                      </div>
                      :
                      null
                    }

                    <input
                       type="file"
                       name="image1ColumnEdit"
                       className={classes.padding4Labels}
                       onChange={(e) => onChangeFileHandlerEdit(e)}
                       accept="image/x-png,image/gif,image/jpeg"
                       />
                  </FormGroup>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormGroup component="fieldset">
                    <FormLabel component="legend">Imagen Mobile</FormLabel>

                    { image2Edit!=='' ?
                      <div className="previewBox">
                        <a href={image2Edit} target="_blank">
                          <img
                            src={image2Edit}
                            className={classes.imgPreview}
                            />
                        </a>
                      </div>

                      :
                      null
                    }

                    <input
                       type="file"
                       name="image2ColumnEdit"
                       className={classes.padding4Labels}
                       onChange={(e) => onChangeFileHandlerEdit(e)}
                       accept="image/x-png,image/gif,image/jpeg"
                       />
                  </FormGroup>
                </Grid>
              </Grid>


            </Fragment>
          }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        { loading ?
            null
          :
            <Fragment>
              <Button onClick={() => handleModalColumnEdit(false)} color="primary">
                Cerrar
              </Button>
              <Button type="submit" color="primary" autoFocus>
                Actualizar
              </Button>
            </Fragment>
        }
        </DialogActions>
        </form>
      </Dialog>
    </div>


      <div>
        <Dialog
          open={open}
          onClose={() => handleModal(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
        <form onSubmit={(e) => handleSubmitDialog(e)}>
          <DialogTitle id="alert-dialog-title">{"Agregar Nueva Fila"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            { loading ?
              <Grid item xs={12} sm={12} className={classes.spinnerDiv}>
                <Loader
                  type="Oval"
                  color="#00BFFF"
                  height={50}
                  width={50}
                  className={classes.spinner}
                />
              </Grid>
              :
              <Fragment>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  label="Titulo de la Fila"
                  name="title"
                  type="text"
                  value={title}
                  onChange={handleChangeDialog}
                />

                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  label="Color del Titulo"
                  name="colorTitle"
                  type="text"
                  value={colorTitle}
                  onChange={handleChangeDialog}
                />

                <TextField
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  label="Sub-titulo (Opcional)"
                  name="subTitle"
                  type="text"
                  value={subTitle}
                  onChange={handleChangeDialog}
                />

                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  label="Color del Sub-titulo"
                  name="colorSubTitle"
                  type="text"
                  value={colorSubTitle}
                  onChange={handleChangeDialog}
                />

                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel id="demo-simple-select-outlined-label">Alineación</InputLabel>
                    <Select
                      label="Alineación del título"
                      name="titleAlign"
                      onChange={handleChangeDialog}
                      value={titleAlign}
                      required
                    >
                      <MenuItem value={"center"}>Center</MenuItem>
                      <MenuItem value={"right"}>Right</MenuItem>
                      <MenuItem value={"left"}>Left</MenuItem>
                    </Select>
                </FormControl>

                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel id="demo-simple-select-outlined-label">Posición de la fila</InputLabel>
                  <Slider
                     defaultValue={position}
                     getAriaValueText={valuetext}
                     aria-labelledby="discrete-slider"
                     valueLabelDisplay="auto"
                     step={1}
                     name="position"
                     marks
                     onChange={handleSlider}
                     min={0}
                     max={rows.length}
                   />
                </FormControl>
              </Fragment>
            }
            </DialogContentText>
          </DialogContent>
          <DialogActions>
          { loading ?
              null
            :
              <Fragment>
                <Button onClick={() => handleModal(false)} color="primary">
                  Cerrar
                </Button>
                <Button type="submit" color="primary" autoFocus>
                  Crear
                </Button>
              </Fragment>
          }
          </DialogActions>
          </form>
        </Dialog>
      </div>


      <div>
        <Dialog
          open={openEdit}
          onClose={() => handleModalEdit(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
        <form onSubmit={(e) => handleSubmitDialogEdit(e)}>
          <DialogTitle id="alert-dialog-title">{"Editar Fila"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            { loading ?
              <Grid item xs={12} sm={12} className={classes.spinnerDiv}>
                <Loader
                  type="Oval"
                  color="#00BFFF"
                  height={50}
                  width={50}
                  className={classes.spinner}
                />
              </Grid>
              :
              <Fragment>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  label="Titulo de la Fila"
                  name="titleSelected"
                  type="text"
                  value={titleSelected}
                  onChange={handleChangeDialogSelected}
                />

                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  label="Color del Titulo"
                  name="colorTitleSelected"
                  type="text"
                  value={colorTitleSelected}
                  onChange={handleChangeDialogSelected}
                />

                <TextField
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  label="Sub-titulo (Opcional)"
                  name="subTitleSelected"
                  type="text"
                  value={subTitleSelected}
                  onChange={handleChangeDialogSelected}
                />

                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  label="Color del Sub-titulo"
                  name="colorSubTitleSelected"
                  type="text"
                  value={colorSubTitleSelected}
                  onChange={handleChangeDialogSelected}
                />

                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel id="demo-simple-select-outlined-label">Alineación</InputLabel>
                    <Select
                      label="Alineación del título"
                      name="titleAlignSelected"
                      onChange={handleChangeDialogSelected}
                      value={titleAlignSelected}
                      required
                    >
                      <MenuItem value={"center"}>Center</MenuItem>
                      <MenuItem value={"right"}>Right</MenuItem>
                      <MenuItem value={"left"}>Left</MenuItem>
                    </Select>
                </FormControl>

                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel id="demo-simple-select-outlined-label">Posición de la fila</InputLabel>
                  <Slider
                     defaultValue={positionSelected}
                     getAriaValueText={valuetext}
                     aria-labelledby="discrete-slider"
                     valueLabelDisplay="auto"
                     step={1}
                     name="position"
                     marks
                     onChange={handleSliderSelected}
                     min={0}
                     max={(rows.length>0 ? rows.length-1 : 0)}
                   />
                </FormControl>
              </Fragment>
            }
            </DialogContentText>
          </DialogContent>
          <DialogActions>
          { loading ?
              null
            :
              <Fragment>
                <Button onClick={() => handleModalEdit(false)} color="primary">
                  Cerrar
                </Button>
                <Button type="submit" color="primary" autoFocus>
                  Actualizar
                </Button>
              </Fragment>
          }
          </DialogActions>
          </form>
        </Dialog>
      </div>

      { loading ?
        <Grid item xs={12} sm={12} className={classes.spinnerDiv1}>
          <Loader
            type="Oval"
            color="#00BFFF"
            height={50}
            width={50}
            className={classes.spinner}
          />
        </Grid>
        :

        <Grid container spacing={3}>
          <Grid item xs={12} sm={8}>
            <Typography component="h4" variant="h4" color="inherit" noWrap className={classes.titleMargin}>
              Estructura de Restaurantes
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Button
              type="submit"
              variant="contained"
              color="default"
              className={classes.btnRight}
              onClick={()=>handleModalColumn(true)}
            >
              Nueva STORE BOX <AddIcon/>
            </Button>

            <Button
              type="submit"
              variant="contained"
              color="primary"
              className={classes.btnRight}
              onClick={()=>handleModal(true)}
            >
              Nueva Fila <AddIcon/>
            </Button>

          </Grid>

          <Divider/>

          <Grid item xs={12} className={classes.titleMargin}>
            { rows.length===0 ?
                  <h5>No existen filas..</h5>
              :
              <div>

              { rows.map((row, index) => (
                  <Paper className={classes.paper} key={index}>
                    <div className={classes.rowTitleMargin}>
                      <h3>
                        <span className={classes.mainTitleMarginRight}>
                          {row.title}
                        </span>
                        <IconButton
                          aria-label="Eliminar"
                          color="secondary"
                          value={row}
                          onClick={() => removeRow(index)}>
                          <DeleteIcon />
                        </IconButton>

                        <IconButton
                          aria-label="Editar"
                          color="primary"
                          onClick={() => handleModalEdit(true, index)}>
                          <EditIcon />
                        </IconButton>

                      </h3>
                      <p>{row.subtitle}</p>
                    </div>

                    <Board
                      disableCardDrag={true}
                      onColumnDragEnd={draggingColumn}
                      renderCard={(card) => (
                        <YCard
                          card={card}
                          setRows={setRows}
                          setLoading={setLoading}
                          handleModalColumnEdit={handleModalColumnEdit}
                         />
                      )}
                      onCardDragEnd={draggingCard}
                    >
                      {row.board}
                    </Board>


                  </Paper>
              )) }

              </div>

            }
          </Grid>
          <Divider />
        </Grid>
      }

    </Fragment>
  );
};

export default RowsStructure;
